module.exports = require('./helpers/bundle-url').getBundleURL('dzWzf') + "logo-dark.eefe0b7f.svg";